import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { FiBell, FiMenu, FiLogOut, FiUser, FiSettings, FiMoon, FiSun, FiHeart } from 'react-icons/fi';
import NotificationPanel from '../common/NotificationPanel';
import logo from '../../assets/logo.png';
import useHeader from './useHeader';
import {
  HeaderContainer, LeftSection, CenterSection, MobileDonateSection, DonateLink,
  MobileDonateLink, Logo, RightSection, NotificationButton, NotificationBadge, UserMenu,
  UserButton, UserAvatar, FallbackAvatar, UserInfo, DropdownMenu, MenuItem, MobileMenuButton
} from './Header.styles';

function Header({ onMenuToggle }) {
  const {
    user, theme, toggleTheme, showUserMenu, setShowUserMenu, showNotificationPanel,
    setShowNotificationPanel, notificationCount, handleLogout, handleProfileClick,
    handleSettingsClick, handleNotificationClick, handleNotificationClose,
    handleNotificationUpdate, handleLogoClick
  } = useHeader();

  return (
    <>
      <HeaderContainer>
        <LeftSection>
          <MobileMenuButton onClick={onMenuToggle}>
            <FiMenu size={20} />
          </MobileMenuButton>

          <Logo onClick={handleLogoClick}>
            <img src={logo} alt="Faith Insight Logo" />
            <h1>Faith Insight</h1>
          </Logo>
        </LeftSection>

        <CenterSection>
          <DonateLink
            to="/donation"
            title="Make a Donation"
          >
            <FiHeart size={16} />
            Donate & Support
          </DonateLink>
        </CenterSection>

        <RightSection>
        <NotificationButton
          onClick={handleNotificationClick}
          data-notification-button
        >
          <FiBell size={20} />
          {notificationCount > 0 && (
            <NotificationBadge>{notificationCount}</NotificationBadge>
          )}
        </NotificationButton>

        <NotificationButton
          onClick={toggleTheme}
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          style={{
            color: theme === 'dark' ? 'var(--primary-color)' : 'var(--text-secondary)',
            transition: 'color 0.3s ease'
          }}
        >
          {theme === 'light' ? <FiMoon size={20} /> : <FiSun size={20} />}
        </NotificationButton>

        <UserMenu data-user-menu>
          <UserButton
            onClick={() => {
              setShowUserMenu(!showUserMenu);
              setShowNotificationPanel(false);
            }}
            data-user-button
          >
            {user?.avatar_url ? (
              <UserAvatar
                src={user.avatar_url}
                alt={`${user?.first_name} ${user?.last_name}`}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <FallbackAvatar style={{ display: user?.avatar_url ? 'none' : 'flex' }}>
              {(user?.first_name?.[0] || '') + (user?.last_name?.[0] || '')}
            </FallbackAvatar>
            <UserInfo>
              <div className="name">{user?.first_name} {user?.last_name}</div>
              <div className="role" style={{
                color: user?.role === 'admin' ? 'var(--primary-color)' : 'var(--text-muted)',
                fontWeight: user?.role === 'admin' ? '600' : '400'
              }}>
                {user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)}
              </div>
            </UserInfo>
          </UserButton>

          <AnimatePresence>
            {showUserMenu && (
              <DropdownMenu
                initial={{ opacity: 0, y: -10, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -10, scale: 0.95 }}
                transition={{ duration: 0.2 }}
              >
                <MenuItem onClick={handleProfileClick}>
                  <FiUser size={16} />
                  Profile
                </MenuItem>
                <MenuItem onClick={handleSettingsClick}>
                  <FiSettings size={16} />
                  Settings
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <FiLogOut size={16} />
                  Sign Out
                </MenuItem>
              </DropdownMenu>
            )}
          </AnimatePresence>
        </UserMenu>

        {/* Notification Panel */}
        <NotificationPanel
          isOpen={showNotificationPanel}
          onClose={handleNotificationClose}
          onUpdate={handleNotificationUpdate}
        />
        </RightSection>
      </HeaderContainer>

      <MobileDonateSection>
        <MobileDonateLink
          to="/donation"
          title="Make a Donation"
        >
          <FiHeart size={16} />
          Donate & Support
        </MobileDonateLink>
      </MobileDonateSection>
    </>
  );
}

export default Header;
